// extracted by mini-css-extract-plugin
export default {"app-layout":"App_app-layout__by0q3","page-wrapper":"App_page-wrapper__c0fhL"};